import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';

export default function OrganizerDashboard() {
    const navigate = useNavigate();

    return (
        <div className="st-page py-12">
            <div className="st-container max-w-3xl">

                <div className="mb-10 text-center animate-fade-in-up">
                    <h1 className="font-display text-3xl md:text-4xl font-bold text-[var(--st-text-primary)] mb-3">
                        👋 ¡Bienvenido al Panel de Control!
                    </h1>
                    <p className="text-[var(--st-text-secondary)] text-lg">
                        Sigue estos pasos para configurar tu cuenta y comenzar a vender.
                    </p>
                </div>

                {/* LISTA VERTICAL DE PASOS */}
                <div className="flex flex-col gap-6">

                    {/* TARJETA 1: PERFIL DE ORGANIZADOR */}
                    <div className="st-card p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 animate-fade-in-up animation-delay-100 hover:border-[var(--st-accent-primary)] transition-all group">

                        {/* Icono */}
                        <div className="w-16 h-16 rounded-2xl bg-[var(--st-accent-primary-light)] text-[var(--st-accent-primary)] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                            <span className="font-display font-bold text-2xl">1</span>
                        </div>

                        {/* Contenido */}
                        <div className="flex-grow">
                            <h3 className="font-display text-xl font-bold mb-2 text-[var(--st-text-primary)]">Completa tu Perfil</h3>
                            <p className="text-[var(--st-text-secondary)] text-sm mb-4 md:mb-0">
                                Genera confianza completando la información de tu organización, subiendo tu logotipo y definiendo tus datos de contacto.
                            </p>
                        </div>

                        {/* Botón */}
                        <div className="w-full md:w-auto flex-shrink-0">
                            <Button
                                variant="secondary"
                                className="w-full md:w-auto group-hover:bg-[var(--st-accent-primary)] group-hover:text-white group-hover:border-transparent transition-colors"
                                onClick={() => navigate('/organizer/business-details')}
                            >
                                Ir al Perfil
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
                            </Button>
                        </div>
                    </div>

                    {/* TARJETA 2: CONFIGURACIÓN DE PAGOS */}
                    <div className="st-card p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 animate-fade-in-up animation-delay-200 hover:border-[var(--st-accent-secondary)] transition-all group">

                        <div className="w-16 h-16 rounded-2xl bg-[var(--st-accent-secondary-light)] text-[var(--st-accent-secondary)] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                            <span className="font-display font-bold text-2xl">2</span>
                        </div>

                        <div className="flex-grow">
                            <h3 className="font-display text-xl font-bold mb-2 text-[var(--st-text-primary)]">Configura Métodos de Pago</h3>
                            <p className="text-[var(--st-text-secondary)] text-sm mb-4 md:mb-0">
                                Ingresa al menos un link de pago (Wompi, Bold o MercadoPago) para que puedas recibir el dinero de tus ventas directamente.
                            </p>
                        </div>

                        <div className="w-full md:w-auto flex-shrink-0">
                            <Button
                                variant="secondary"
                                className="w-full md:w-auto group-hover:bg-[var(--st-accent-secondary)] group-hover:text-white group-hover:border-transparent transition-colors"
                                onClick={() => navigate('/organizer/payment-gateways')}
                            >
                                Configurar
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
                            </Button>
                        </div>
                    </div>

                    {/* TARJETA 3: CREAR EVENTO */}
                    <div className="st-card p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 animate-fade-in-up animation-delay-300 hover:border-[var(--st-success)] transition-all group">

                        <div className="w-16 h-16 rounded-2xl bg-[var(--st-success-light)] text-[var(--st-success)] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                            <span className="font-display font-bold text-2xl">3</span>
                        </div>

                        <div className="flex-grow">
                            <h3 className="font-display text-xl font-bold mb-2 text-[var(--st-text-primary)]">Crea tu Primer Evento</h3>
                            <p className="text-[var(--st-text-secondary)] text-sm mb-4 md:mb-0">
                                Define el nombre, fecha, lugar y las etapas de venta. Sube un flyer atractivo y comienza a vender boletas hoy mismo.
                            </p>
                        </div>

                        <div className="w-full md:w-auto flex-shrink-0">
                            <Button
                                variant="secondary"
                                className="w-full md:w-auto group-hover:bg-[var(--st-success)] group-hover:text-white group-hover:border-transparent transition-colors"
                                onClick={() => navigate('/organizer/events/create')}
                            >
                                Crear Evento
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}